import { CreditCardType } from '@platform-frontend/payment-util';
import { ReusablePaymentMethodBase } from './reusable-payment-method-base';

export interface CreditCard extends ReusablePaymentMethodBase {
  type: 'CREDIT_CARD';
  cardType: CreditCardType;
  holderName: string;
  maskedNumber: string;
  expiryMonth: number;
  expiryYear: number;
  encryptedString?: string;
  skipSca?: boolean;
}
